
<!--更换记录：更换记录-->
<template>
  <div class="app-container">
    <!--页头-->
    <div class="page-container">
      <div class="section">
        <div class="control-box">
          <div class="cb-left">
            <h1 style="font-size: 20px;">{{ $t('replacement_record') }}</h1>
          </div>
        </div>
        <div class="table-box">
          <div class="control-search">
            <!--添加按钮-->
            <div class="cb-left">
              <span style="font-size:14px">{{ $t('device_type') }} </span>
              <el-select
                  v-model="maintainanceForm.deviceId"
                  clearable
                  :placeholder="$t('xuanzeDevice')"
                  style="width: 200px;margin-left:10px;margin-right: 10px"
              >
                <el-option
                    v-for="item in option1"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
              <el-button
                  class="control-item"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleSearch"
              >
                {{ $t('search') }}
              </el-button>
              <el-button :loading="loading" v-if="roleType === 3 || roleType === 2" type="primary" @click="handleExport()" >
                {{ $t('BatchExport') }}
              </el-button>
            </div>
          </div>
          <div>
            <div class="table-box">
              <el-table
                  :data="maintainanceData"
                  border
                  highlight-current-row
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" v-if="roleType === 3 || roleType === 2" model="" width="50" ></el-table-column>
                <el-table-column :label="$t('deviceName')" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.name }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('replacement_item')" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.project }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('submit_time')" align="center" width="150">
                  <template slot-scope="scope">
                    <span>{{scope.row.date}}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('device_state')" align="center" width="150">
                  <template slot-scope="scope">
                    <div style="color:#37C239; font-weight: bold" v-if="scope.row.result === '1'">{{ $t('approved')}}</div>
                    <div style="color:#666; font-weight: bold" v-else>{{ scope.row.result === '0' ? $t('unreviewed') : scope.row.result === '2' ? $t('rejected') :$t('overtime_cancellation')}}</div>
                  </template>
                </el-table-column>
                <!--操作-->
                <el-table-column :label="$t('caozuo')" header-align="center" align="center" width="240">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="checkReplacement(scope.row.id)">
                      {{ $t('device_view') }}
                    </el-button>
                    <el-button type="primary" size="mini" v-if="roleType === 3 || roleType === 2" @click="handleExport(scope.row)" plain >
                      {{ $t('export') }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pagination-box">
              <el-pagination
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="maintainanceForm.count"
                  :total="maintainanceCount"
                  :current-page="maintainanceForm.page"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api';
import {base64toFile} from '@/utils/file';
import moment from "moment";

export default {
  name: "replacementRecord",
  data() {
    return {
      abnormal: [],// 异常提报
      option1: [],
      maintainanceForm: {
        count: 10,
        page:1,
        deviceId: ''
      },
      exportData: [],
      abnormalCount: 0,
      maintainanceData: [],// 定期更换
      loading: false,
      maintainanceCount: 0,
      totalCount: 0,
      faultList: [],// 异常提报
      faultForm: {
        page: 1,
        count: 10,
        type: 3
      },
      faultCount: 0,
      activeName: 'first',
      rules: {},
    };
  },
  computed: {
    roleType() {
      // this.value1 = localStorage.getItem('deviceId')
      return this.$store.state.userInfo.roleType
    },
  },
  created() {
    this.maintainanceForm.page = this.$store.state.replacementForm.page
    this.maintainanceForm.count = this.$store.state.replacementForm.count
    this.maintainanceForm.deviceId = this.$store.state.replacementForm.deviceId
    this.getList()
    this.getDevice()
  },
  mounted() {

  },
  methods: {
    handleSearch() {
      this.maintainanceForm.page = 1
      this.getList()
    },
    getList() {
      API.regularList(this.maintainanceForm).then(res => {
        this.maintainanceData = res.message.data.list
        this.maintainanceCount = res.message.data.totalCount
      })
    },
    getDevice() {
      API.regularDeviceList().then(res => {
        this.option1.push(...res.message.data)
        this.option1.unshift({name: this.$t('alldevice'), id: ''})
      })
    },
    dateFmt(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
    },
    // 查看
    checkReplacement(id) {
      this.$store.commit('replacementSet', {page: this.maintainanceForm.page,count: this.maintainanceForm.count, deviceId: this.maintainanceForm.deviceId});
      this.$router.push({ path: 'replacementDetail', query: {id:id}});
    },
    handleSelectionChange(val) {
      this.exportData = val
      console.log(this.exportData);
    },
    // 导出
    handleExport(row) {
      console.log(this.exportData);
      console.log(this.exportData.length < 1 && row)
      if (this.exportData.length < 1 && !row) {
        this.$message.warning(this.$t('pleaseSelectDataExport'))
        return
      }
      if(row) {
        this.exportData = [{...row}]
      }
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/views/ExcelLeadOut/Export2Excel'); // 注意这个Export2Excel路径
        const tHeader = [
          this.$t('device_add_name'),
          this.$t('submission_sheet_number'),
          this.$t('submit_time'),
          this.$t('replacement_item'),
          this.$t('device_state'),
          this.$t('remark'),
          this.$t('approval_result'),
          this.$t('approver'),
          this.$t('approval_time'),

        ]; // 表格标题
        const filterVal = [
          'name',
          'code',
          'date',
          'project',
          'result',
          'remark',
          'result',
          'approvePerson',
          'approveDate',

        ]; // 标题属性key值
        // API.abnormalWebList({...this.query,startTime: this.startTime,endTime:this.endTime,deviceId: this.equipmentDown,count:100000,page: 1}).then(res => {
        const list = this.exportData.map(item => {
          // 复制原对象避免修改源数据
          const newItem = {...item};
          // 根据state值转换为对应文字
          switch(newItem.result) {
            case '1':
              newItem.result = this.$t('approved'); // 未完成
              break;
            case '2':
              newItem.result = this.$t('rejected');  // 已完成
              break;
            case '0':
                newItem.result = this.$t('unreviewed');  // 已完成
                break;
            default:
              newItem.result = this.$t('overtime_cancellation'); // 未知状态（可选）
          }
          return newItem;
        });// 把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, this.$t('replacementRecordExportDataTable'),this.$t('replacement_record')); // 倒数第二个是表名字，最后一个是sheet表名字
        // })

      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    back() {
      this.$router.go(-1);
    },
    handleSizeChange(val) {
      this.maintainanceForm.count = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.maintainanceForm.page = val ;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.table-box {
  position: relative;
}

::v-deep .dialog-footer {
  text-align: right;
}

::v-deep .el-tabs__active-bar {
  height: 2px;
  background-color: #F3A100;
}

.control-item {

}

.control-btn {
  text-align: right;
  position: absolute;
  right: 0px;
  top: -0px;
  z-index: 9999;
}

.control-box1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  position: absolute;
  right: 21px;
  top: 127px;
  z-index: 999;
}

.btn {
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  width: 100%;
  border-radius: 4px;
  line-height: 1;
  height: 40px;
  padding: 12px 10px 0px 15px;
  color: #cccfd6;
  cursor: pointer;
}

.person {
  margin-bottom: 20px;
}

.history {
  text-align: right;
}

.record {
  margin-bottom: 0px;

  img {
    width: 15px;
    margin-right: 10px;
  }

  span {
    //display: inline-block;
    text-align: right;
    width: 100%;
    cursor: pointer;
  }
}

.pic-and-video-wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .btn {
    width: 90px;
    height: 90px;
    margin-top: 10px;
    background-color: #f1f1f1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    border: 0;
    padding: 0;

    img {
      width: 20px;
      height: 20px;
    }

    span {
      margin-top: 5px;
      font-size: 13px;
      color: grey;
    }

    .closeVideo-btn {
      margin-top: 8px;
    }
  }
}

.preview {
  width: 90px;
  height: 90px;
  margin-top: 10px;
  margin-right: 10px;
  position: relative;

  img {
    position: absolute;
    width: 90px;
    height: 90px;
  }

  .van-btton {
    position: absolute;
    right: 0;
    font-size: 20px;
    //top: -15px;
    background: #fff;
    padding: 0;
    color: #f56c6c;
  }
}

.voice {
  width: 100%;
  height: 34px;
  border-radius: 17px;
  background-color: #f1f1f1;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 22px;
    height: 22px;
  }
}

.video-label {
  width: 100%;
  height: 34px;
  border-radius: 17px;
  background-color: lightgrey;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
  font-size: 13px;
  color: grey;

  .close-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.item {
  padding: 8px 10px;

  img {
    width: 32px;
    margin-right: 10px;
  }
}

.item:hover {
  background-color: #FFFAED;
}

.list-item {
  display: flex;
  justify-content: space-between;
  color: #9F9F9F;
  font-size: 14px;

  .name {
    color: #3D3D3D;
    font-size: 16px;
    margin-bottom: 10px;
  }

  padding: 15px 0;
  border-bottom: 1px solid #F1F1F1;
}

.item-left {
  display: flex;

  img {
    width: 56px;
    margin-right: 15px;
  }
}

.control-search {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 0 20px;
  //项
  .control-item {
    display: inline-block;

    + .control-item {
      margin-left: 10px;
    }
  }

  //左栏
  .cb-left {
  }

  //右栏
  .cb-right {
  }

  //表单项
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>

